import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import FakeRadio from '../FakeRadio';
import { getPackageById } from '../../../reducers/packages';
import { formatDaysKey } from '../../../utils/packagesUtils';
import { BASIC_PACKAGE_ID, STANDARD_PACKAGE_ID, PREMIUM_PACKAGE_ID } from '../../../utils/packagesUtils/constants';

const getDelivery = (packages, packageId) => {
    const packageData = getPackageById(packages, packageId);
    const { extraFast, duration } = packageData;

    return {
        extraFast,
        duration,
        packageId
    };
};

const renderPackageDeliveryTime = ({ extraFast, duration: days, packageId }, showSelection) => {
    const shouldRenderSelection = extraFast && showSelection;

    return (
        <td key={packageId}>
            {shouldRenderSelection ?
                <FakeRadio packageId={packageId}/> :
                <>{days} <I18n k={formatDaysKey(days)}/></>
            }
        </td>
    );
};

const DeliveryTime = ({ basicDelivery, standardDelivery, premiumDelivery, showSelection }) => {
    const deliveries = [premiumDelivery, standardDelivery, basicDelivery];

    return (
        <tr className="delivery-time">
            <th><I18n k={'gig_page_perseus.packages_table.delivery_time'}/></th>
            {
                deliveries.map((delivery) => renderPackageDeliveryTime(delivery, showSelection))
            }
        </tr>
    );
};

DeliveryTime.propTypes = {
    showSelection: PropTypes.bool
};

DeliveryTime.defaultProps = {
    showSelection: true
};

const mapStateToProps = ({ packages }) => ({
    basicDelivery: getDelivery(packages, BASIC_PACKAGE_ID),
    standardDelivery: getDelivery(packages, STANDARD_PACKAGE_ID),
    premiumDelivery: getDelivery(packages, PREMIUM_PACKAGE_ID)
});

export { DeliveryTime };
export default connect(mapStateToProps)(DeliveryTime);
